import { useEffect, useState } from 'react';
import { Constants } from '@/constants/constants';
import { Remote } from '@/api/remote';
import { ApiConstant } from '@/constants/api_constants';
import { Util } from '@/utils/utils';

const ASK_TYPE_SERVICE = 'AAKTYPE002';
const FRNC_ID_PARTNERSHIP = 'STELLA';
interface FormData {
	companyName: string;
	userName: string;
	userNumber: string;
	userMail: string;
	userInquiry: string;
	inquiryAgree: boolean;
}

const useInquiryForm = () => {
	const [formData, setFormData] = useState<FormData>({
		companyName: '',
		userName: '',
		userNumber: '',
		userMail: '',
		userInquiry: '',
		inquiryAgree: false
	});

	const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

	// 입력값 변경을 처리하는 함수
	const handleInputChange = (e: any) => {
		const { id, value, type, checked } = e.target;
		setFormData(prev => ({
			...prev,
			[id]: type === 'checkbox' ? checked : value
		}));
	};

	// 폼 데이터 제출 처리
	const inquirySvcClickSubmit = async () => {
		const { companyName, userName, userNumber, userMail, userInquiry, inquiryAgree } = formData;

		if (!companyName) {
			alert('회사명을 입력해 주세요.');
			return;
		}
		if (!userName) {
			alert('이름을 입력해 주세요.');
			return;
		}
		if (!userNumber) {
			alert('연락처를 정확히 입력해 주세요.');
			return;
		}
		if (!userMail || !Util.isEmail(userMail)) {
			alert('이메일을 정확히 입력해 주세요.');
			return;
		}
		if (!userInquiry) {
			alert('문의 내용을 입력해 주세요.');
			return;
		}

		const jsonData = {
			applyAskerBizNm: companyName,
			applyAskerNm: userName,
			applyAskerPhoneNo: userNumber,
			applyAskerEmail: userMail,
			applyAskCtnt: userInquiry.replace(/\n/g, '<br>'),
			applyAskType: ASK_TYPE_SERVICE,
			agreeYn: inquiryAgree ? Constants.yes : Constants.no,
			frncId: FRNC_ID_PARTNERSHIP
		};

		try {
			const response = await Remote.Api.post(ApiConstant.mgmtApplyAsk.save, jsonData);
			if (response.code !== Constants.apiSuccess) {
				alert(response.message);
				return;
			}

			alert('문의하기가 성공적으로 전송되었습니다.');
			setFormData({
				companyName: '',
				userName: '',
				userNumber: '',
				userMail: '',
				userInquiry: '',
				inquiryAgree: false
			});
			window.scrollTo(0, 0);
		} catch (error) {
			console.error('Error submitting inquiry:', error);
		}
	};

	// 체크박스 동작을 추적하고 폼 제출 활성화 여부를 설정
	useEffect(() => {
		setIsSubmitEnabled(formData.inquiryAgree);
	}, [formData.inquiryAgree]);

	return {
		formData,
		isSubmitEnabled,
		handleInputChange,
		inquirySvcClickSubmit
	};
};

export default useInquiryForm;
